module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/notokr-light.woff
// module id = mL55
// module chunks = 0